import React, {useState, useEffect} from "react";
import Grid from '@material-ui/core/Grid';
import CircularProgress from "@material-ui/core/CircularProgress";
import RadiusPieChart from "../../Component/RaduisPieChart/RaduisPieChart";
import HeaderPage from "../../Component/HeaderPage/HeaderPage";

import classNames from "classnames";
import './index.css'
import ColumnCylinder from "../../Component/CylinderColumnChart/ColumnCylinder";

const ServiceNow = () => {
  const [dataset, setData] = useState([]);
  const [chart, setChart ] = useState(1)

  useEffect(() => {
    const URL = "https://apm-app3.alphait.us/ServiceNow/GetServiceNowData"

    fetch(URL)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setData(data);
      });

  }, []);

  const handleChart = (key) => {
    setChart(key)
  }

  const typeChart = {
    1: <ColumnCylinder datasets={dataset.res} legend dy={-20}/>,
    2: <RadiusPieChart datasets={dataset.res}/>
  }

  return (
    <div className="service-now">
      <HeaderPage text="service now" />
      <span className="service-type">TYPE OF INCIDENTS</span>
     <div className="toggle-wrap">
       <div className="service-toggle">
        <span
          className={classNames('service-toggle-label', chart === 1 && 'active-chart')}
          key='1'
          onClick={() => handleChart(1)}
        >chart 1</span>
         <span
           className={classNames('service-toggle-label', chart === 2 && 'active-chart')}
           key='2'
           onClick={() => handleChart(2)}
         >chart 2</span>
       </div>
     </div>
      <Grid className="service-chart" item>
        {dataset.res ? (
          <>
            <Grid xs={10} className="chart-box">
              {typeChart[chart]}
            </Grid>
          </>
        ) : (
          <div className="service-loading">
            <span className="service-loading-label">Loading data from server...</span>
            <CircularProgress/>
          </div>
        )}
      </Grid>
    </div>
  );
}

export default ServiceNow